const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class SearchPromos extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        disabled: true,
        breakpoints: {
          '(min-width: 768px)': {
            disabled: false,
            slides: {
              perView: 3,
              spacing: 5,
            },
          },
        },
      },
      [setInitialised()],
    )
  }
}

if (!customElements.get('search-promos')) {
  customElements.define('search-promos', SearchPromos)
}
